import _slicedToArray from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import { Country, toCountry, toCountryFromLocale } from './country';

function invertStringKeyValues(obj) {
  var ret = {};
  Object.keys(obj).forEach(function (key) {
    ret[obj[key]] = key;
  });
  return ret;
}

export var Language;

(function (Language) {
  Language["English"] = "en";
  Language["German"] = "de";
  Language["Spanish"] = "es";
  Language["PseudoLocalization"] = "pseudo-localization";
  Language["EnglishBeta"] = "uz";
  Language["French"] = "fr";
})(Language || (Language = {}));

export var TLDSupportedLanguages = {
  '.com': [Language.English],
  '.co.uk': [Language.English],
  '.ca': [Language.English, Language.French],
  '.de': [Language.German],
  '.com.au': [Language.English],
  '.es': [Language.Spanish],
  '.mx': [Language.Spanish]
};
export var languageCodeToName = invertStringKeyValues(Language);
export var isLanguage = function isLanguage(str) {
  return Object.values(Language).includes(str);
};
export var toLanguage = function toLanguage() {
  var country = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : toCountry();
  return country === Country.Germany ? Language.German : Language.English;
};
export var toLanguageFromLocale = function toLanguageFromLocale(locale) {
  var _locale$split = locale.split('-'),
      _locale$split2 = _slicedToArray(_locale$split, 1),
      language = _locale$split2[0];

  return isLanguage(language) ? language : toLanguage(toCountryFromLocale(locale));
};